import { FC } from 'react';
import { Text, CheckCircle } from '@doda/io-react/common';
import { TAB_JOBDETAIL } from '@doda/common/src/constants/properties/const';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { tabSelector } from '@doda/pc/src/redux/selectors/queryParams';
import { CheckMarkBalloon } from '../CheckMarkBalloon';
import styles from './index.module.scss';
import { Tab } from '../../types/tab';

/**
 * ArticleSummaryのProps
 */
export interface Props {
  articleSummaryList: string[];
  initialTab: Tab;
}

/**
 * 記事要約コンポーネント
 */
export const ArticleSummary: FC<Props> = ({
  articleSummaryList,
  initialTab,
}) => {
  const tab = useAppSelector(tabSelector) ?? initialTab;
  if (tab !== TAB_JOBDETAIL) return null;
  return (
    <div className={styles['jobSearchDetail-articleSummary__wrapper']}>
      <div
        className={styles['jobSearchDetail-articleSummary__checkMarkPosition']}
      >
        <CheckMarkBalloon />
      </div>
      <div className={styles['jobSearchDetail-articleSummary_title']}>
        <Text color="white" size="14--articlePC" weight="bold">
          この求人を要約すると
          <span
            className={styles['jobSearchDetail-articleSummary__textEllipsis']}
          >
            …
          </span>
        </Text>
      </div>
      <div className={styles['jobSearchDetail-articleSummary__contents']}>
        {articleSummaryList.map((articleSummary, i) => (
          <div
            key={i}
            className={styles['jobSearchDetail-articleSummary__item']}
          >
            <CheckCircle size="M" color="blue" />
            <Text color="black_pc" size="14--articlePC" weight="bold">
              {articleSummary}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
};
